// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__s9xkj","text":"title_text__3l5r2","more":"title_more__6-JIr"};